import { useLingui } from "@lingui/react";
import { ApiSmpArtGallery } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery } from "react-query";
import { UseQueryOptions } from "react-query/types/react/types";

const KEY_POLOTNO_STICKERPACK = "polotno.stickerpack";

export const useQueryPolotnoStickerpack = (
  id?: number,
  options?: Omit<
    UseQueryOptions<
      Await<ReturnType<typeof ApiSmpArtGallery.Polotno.stickerpack>>
    >,
    "queryKey" | "queryFn" | "getNextPageParam"
  >,
) => {
  const {
    i18n: { locale },
  } = useLingui();

  const params = {
    id: id || 0,
    text_lang: locale,
  };

  return useQuery<
    Await<ReturnType<typeof ApiSmpArtGallery.Polotno.stickerpack>>
  >(
    [KEY_POLOTNO_STICKERPACK, params],
    () => ApiSmpArtGallery.Polotno.stickerpack(params),
    {
      ...options,
      enabled: !!params.id && options?.enabled,
    },
  );
};

useQueryPolotnoStickerpack.KEY = KEY_POLOTNO_STICKERPACK;
